import { Database } from '@databases/model/database';
import { DefaultRootState } from '@databases/redux';
import { DatabaseChangeType } from '@databases/types/redux';

import { yjsHandlerIgnoreMap } from './handlers/handler-ignore-map';
import { yjsCallbackHandlerMap } from './handlers/handler-map';
import { DatabaseChangeForType, YJSCallbackChangeContext } from './types';

export const addChangeToYjs = <T extends DatabaseChangeType>(
  ydb: Database,
  change: DatabaseChangeForType<T>,
  state: DefaultRootState | undefined,
  /**
   * Map of change types to their corresponding handlers.
   * This is only passed for testing purposes.
   */
  callbackMap = yjsCallbackHandlerMap,

  /**
   * Set of change types to ignore.
   * This is only passed for testing purposes.
   */
  ignoreMap = yjsHandlerIgnoreMap
): void => {
  if (ignoreMap.has(change.type)) {
    return;
  }

  const handler = callbackMap[change.type];

  if (handler) {
    const callbackContext: YJSCallbackChangeContext<T> = {
      ydb,
      change,
      state,
    };

    handler(callbackContext);
  } else {
    // eslint-disable-next-line no-console
    console.error('unknown change type', change.type, change);
  }
};
